module.exports = __webpack_public_path__ + "img/title2.a0deceb2.png";